import React, { useEffect, useState } from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import Sidebar from '../sidebar/Sidebar';
import { useSelector } from 'react-redux';

function Layout({ children,setUser }) {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { lang } = useSelector((state) => state.language);

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth < 768;
      setIsMobile(isNowMobile);
      if (!isNowMobile) {
        setSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen relative overflow-hidden ">
     
      <div className="z-50 bg-gray-900 ">
        <Sidebar
          isOpen={sidebarOpen}
          language={lang}
          isMobile={isMobile}
        />
      </div>

     
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSidebar}
        />
      )}

      
      <div className="flex-1 flex flex-col relative z-30">
        <div className="z-50 relative">
          <Header
            toggleSidebar={toggleSidebar}
            language={lang} 
            
            setUser={setUser}
          />
        </div>

        <main className="flex-1 overflow-y-auto z-30 relative bg-gray-900 scrollbar-hide ">
          {children}
        </main>

        <div className="z-30 relative">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Layout;
